module.exports = __webpack_public_path__ + "img/ny.03dea953.jpg";